class DeliveryPicker extends HTMLElement {
  constructor() {
    super();

    this.phsLabel = this.querySelector("[data-phs-option]");
    this.freeLabel = this.querySelector("[data-free-option]");
    this.pickupLabel = this.querySelector("[data-pickup-option]");
  }

  connectedCallback() {
    this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";

    this.updateUI();
    this.updateCart();
    this.updateLabels();

    document.addEventListener("delivery-method-changed", () => {
      this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";
      this.updateLabels();
    });

    this.phsLabel.addEventListener("click", () =>
      this.onDeliveryMethodChanged("phs")
    );
    this.pickupLabel.addEventListener("click", () =>
      this.onDeliveryMethodChanged("pickup")
    );
    if (this.freeLabel)
      this.freeLabel.addEventListener("click", () =>
        this.onDeliveryMethodChanged("free")
      );
  }

  updateLabels() {
    if (this.deliveryMethod === "phs") {
      this.phsLabel.querySelector("input").checked = true;
      this.pickupLabel.querySelector("input").checked = false;
      if (this.freeLabel) this.freeLabel.querySelector("input").checked = false;
    } else if (this.deliveryMethod === "free") {
      this.phsLabel.querySelector("input").checked = false;
      this.pickupLabel.querySelector("input").checked = false;
      if (this.freeLabel) this.freeLabel.querySelector("input").checked = true;
    }
    else if (this.deliveryMethod === "pickup") {
      this.phsLabel.querySelector("input").checked = false;
      this.pickupLabel.querySelector("input").checked = true;
      if (this.freeLabel) this.freeLabel.querySelector("input").checked = false;
    }
  }

  updateUI() {
    if (this.deliveryMethod === "free") {
      if (this.freeLabel) this.freeLabel.classList.add("selected");
      this.phsLabel.classList.remove("selected");
      this.pickupLabel.classList.remove("selected");
    } else if (this.deliveryMethod === "phs") {
      this.phsLabel.classList.add("selected");
      this.pickupLabel.classList.remove("selected");
      if (this.freeLabel) this.freeLabel.classList.remove("selected");
    } else if (this.deliveryMethod === "pickup") {
      this.phsLabel.classList.remove("selected");
      this.pickupLabel.classList.add("selected");
      if (this.freeLabel) this.freeLabel.classList.remove("selected");
    }
  }

  onDeliveryMethodChanged(newMethod) {
    const changeItemsInCart = document.querySelector("[data-delivery-method-change-items-in-cart]");
    if(changeItemsInCart && newMethod !== "pickup") {
      this.showPopup(newMethod);
    }
    else {
      this.confirmMethod(newMethod);
    }
  }

  showPopup(newMethod) {
    const moqPopup = document.querySelector(".moq-popup-wrapper");
    const mopText = document.querySelector(".moq-popup__text");
    mopText.innerText = document.querySelector("[data-delivery-method-change-items-in-cart]").getAttribute("data-delivery-method-change-items-in-cart");
    
    const mopActionItems = document.querySelector(".moq-popup__action-items");
    mopActionItems.innerHTML = "";
    const cancelButton = document.createElement("button");
    cancelButton.classList =
      "button button--solid button--regular button--regular-mobile";
    cancelButton.innerText = "Cancel";
    cancelButton.addEventListener("click", () => {
      moqPopup.classList.remove("show");
      this.updateUI();
      this.updateCart();
      this.updateLabels();  
    });

    mopActionItems.appendChild(cancelButton);

    const confirmButton = document.createElement("button");
    confirmButton.classList =
      "button button--solid button--regular button--regular-mobile";
    confirmButton.innerText = "Confirm";
    confirmButton.addEventListener("click", () => {
      this.confirmMethod(newMethod);
      moqPopup.classList.remove("show");
    });

    mopActionItems.appendChild(confirmButton);

    moqPopup.classList.add("show");
  }

  confirmMethod(newMethod) {
    this.deliveryMethod = newMethod;
    localStorage.setItem("shippingMethod", this.deliveryMethod);

    this.updateUI();
    this.updateCart();

    const event = new CustomEvent("delivery-method-changed", {
      detail: {
        newDeliveryMethod: newMethod,
      },
    });

    document.dispatchEvent(event);
  }

  updateCart() {
    const cartShippingMethod = document.querySelector(
      "[data-cart-shipping-method]"
    );
    if (!cartShippingMethod) return;

    if (this.deliveryMethod === "phs")
      cartShippingMethod.innerHTML = "Prime Hay Service (€0.75 per km)";
    else cartShippingMethod.innerHTML = "FREE Shipping";
  }
}

customElements.define("delivery-picker", DeliveryPicker);

class DeliveryPickerVariants extends HTMLElement {
  constructor() {
    super();

    this.phsLabel = this.querySelector("[data-phs-option]");
    this.freeLabel = this.querySelector("[data-free-option]");
    this.pickupLabel = this.querySelector("[data-pickup-option]");

    this.moqNote = document.querySelector("[data-delivery-moq-note]");
    this.quantitySelectorInput = document.querySelector("[data-js-product-quantity]").querySelector("input");
  }

  connectedCallback() {
    this.deliveryMethod = this.getSelectedMethod();

    this.phsLabel.addEventListener("click", () =>
      this.confirmMethod("phs")
    );
    this.pickupLabel.addEventListener("click", () =>
      this.confirmMethod("pickup")
    );
    if (this.freeLabel)
      this.freeLabel.addEventListener("click", () =>
        this.confirmMethod("free")
    );

    setTimeout(() => {
      this.confirmMethod(this.deliveryMethod);
    }, 200);
  }

  getSelectedMethod() {
    const phsInput = this.phsLabel.querySelector("input");
    if(this.freeLabel) {
      const freeInput = this.freeLabel.querySelector("input");
    }
    const pickupInput = this.pickupLabel.querySelector("input");
    if(phsInput.checked) return "phs"
    if(this.freeLabel && freeInput.checked) return "free"
    if(pickupInput.checked) return "pickup"
    return "phs"
  }

  confirmMethod(newMethod) {
    this.deliveryMethod = newMethod;
    if(this.moqNote) {
      if(this.deliveryMethod == "phs") this.moqLimitShow();
      else this.moqLimitHide();
    }

    const event = new CustomEvent("delivery-method-changed", {
      detail: {
        newDeliveryMethod: newMethod,
      },
    });

    document.dispatchEvent(event);
  }

  moqLimitShow() {
    this.moqNote.classList.remove("hide");
    // this.quantitySelectorInput.setAttribute("min", 5);
    // this.quantitySelectorInput.setAttribute("value", 5);
  }
  
  moqLimitHide() {
    this.moqNote.classList.add("hide");
    // this.quantitySelectorInput.setAttribute("min", 1);
    // this.quantitySelectorInput.setAttribute("value", 1);
  }
}

customElements.define("delivery-picker-variants", DeliveryPickerVariants);

class DeliveryPickerCart extends HTMLElement {
  constructor() {
    super();

    this.shippingSelectors = this.querySelectorAll("[data-shipping-app]");
    this.pickupSelectors = this.querySelectorAll("[data-pickup-app]");

    this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";
  }

  connectedCallback() {
    this.shippingSelectors.forEach((selector) => {
      selector.addEventListener(
        "click",
        this.shippingSelected.bind(this, selector, true)
      );
    });
    this.pickupSelectors.forEach((selector) => {
      selector.addEventListener(
        "click",
        this.pickupSelected.bind(this, selector, true)
      );
    });
    document.addEventListener("delivery-method-changed", () => {
      this.deliveryMethod = localStorage.getItem("shippingMethod") || "free";
      if(this.deliveryMethod == 'free') {
        this.shippingSelected(this.shippingSelectors[0], false);
      }
      else if (this.deliveryMethod == 'phs'){
        this.shippingSelected(this.shippingSelectors[1], false);
      }
      else if (this.deliveryMethod == 'pickup') {
        this.pickupSelected(this.pickupSelectors[0], false)
      }
    });

    // waiting for app to load to update shipping methods
    let retryCount = 10;
    const intervalId = setInterval(() => {
      if(retryCount == 0) clearInterval(intervalId);
      const appMethodsContainer = document.querySelector(
        ".checkoutMethodsContainer"
      );
      if(appMethodsContainer) {
        if(this.deliveryMethod == 'free') {
          this.shippingSelectors[0].click();
        }
        else if (this.deliveryMethod == 'phs'){
          this.shippingSelectors[1].click();
        }
        else if (this.deliveryMethod == 'pickup') {
          setTimeout(() => {
            this.pickupSelectors[0].click();
          }, 2500);
        }
        clearInterval(intervalId);
      }
      retryCount--;
    }, 200);
  }

  shippingSelected(container, dispatchEvent) {
    const newMethod = container.getAttribute("data-shipping-method");
    const changeItemsInCart = document.querySelector("[data-delivery-method-change-items-in-cart]");
    if(changeItemsInCart && this.init >= 0) {
      if(newMethod == localStorage.getItem("shippingMethod")) return;
      this.showPopup(newMethod, dispatchEvent, container);
    }
    else {
      this.confirmMethod(newMethod, dispatchEvent, container) 
    }
    this.init = this.init ? this.init + 1 : 0;
    
    // this.deselectActive();
    // const appMethodsContainer = document.querySelector(
    //   ".checkoutMethodsContainer"
    // );
    // const appShipping =
    //   appMethodsContainer.querySelectorAll(".checkoutMethod")[0];
    // localStorage.setItem("shippingMethod", newMethod);

    // container.classList.add("active");
    // this.startLoading();
    // if (appShipping) appShipping.click();

    // if(dispatchEvent) {
    //   const event = new CustomEvent("delivery-method-changed", {
    //     detail: {
    //       newDeliveryMethod: newMethod,
    //       changedFromCart: true
    //     },
    //   });

    //   document.dispatchEvent(event);
    // }
  }

  showPopup(newMethod, dispatchEvent, container) {
    const moqPopup = document.querySelector(".moq-popup-wrapper");
    const mopText = document.querySelector(".moq-popup__text");
    mopText.innerText = document.querySelector("[data-delivery-method-change-items-in-cart]").getAttribute("data-delivery-method-change-items-in-cart");
    
    const mopActionItems = document.querySelector(".moq-popup__action-items");
    mopActionItems.innerHTML = "";
    const cancelButton = document.createElement("button");
    cancelButton.classList =
      "button button--solid button--regular button--regular-mobile";
    cancelButton.innerText = "Cancel";
    cancelButton.addEventListener("click", () => {
      moqPopup.classList.remove("show");
    });

    mopActionItems.appendChild(cancelButton);

    const confirmButton = document.createElement("button");
    confirmButton.classList =
      "button button--solid button--regular button--regular-mobile";
    confirmButton.innerText = "Confirm";
    confirmButton.addEventListener("click", () => {
      this.confirmMethod(newMethod, dispatchEvent, container);
      moqPopup.classList.remove("show");
    });

    mopActionItems.appendChild(confirmButton);

    moqPopup.classList.add("show");
  }

  confirmMethod(newMethod, dispatchEvent, container) {
    this.deselectActive();
    const appMethodsContainer = document.querySelector(
      ".checkoutMethodsContainer"
    );
    const appShipping =
      appMethodsContainer.querySelectorAll(".checkoutMethod")[0];
    localStorage.setItem("shippingMethod", newMethod);

    container.classList.add("active");
    this.startLoading();
    if (appShipping) appShipping.click();

    if(dispatchEvent) {
      const event = new CustomEvent("delivery-method-changed", {
        detail: {
          newDeliveryMethod: newMethod,
          changedFromCart: true
        },
      });

      document.dispatchEvent(event);
    }
  }

  pickupSelected(container, dispatchEvent) {
    this.deselectActive();
    const appMethodsContainer = document.querySelector(
      ".checkoutMethodsContainer"
    );
    const appPickup =
      appMethodsContainer.querySelectorAll(".checkoutMethod")[1];
    localStorage.setItem("shippingMethod", container.getAttribute("data-shipping-method"));

    container.classList.add("active");
    this.startLoading();
    if (appPickup) appPickup.click();

    if(dispatchEvent) {
      const event = new CustomEvent("delivery-method-changed", {
        detail: {
          newDeliveryMethod: container.getAttribute("data-shipping-method"),
          changedFromCart: true
        },
      });
  
      document.dispatchEvent(event);
    }
  }

  deselectActive() {
    const activeMethod = this.querySelector(".shippingMethod.active");
    if (activeMethod) activeMethod.classList.remove("active");
  }

  // needed because the app takes time to load
  startLoading() {
    this.classList.add("loading");

    setTimeout(() => {
      this.finishLoading();
    }, 1700);
  }

  finishLoading() {
    this.classList.remove("loading");
  }
}

customElements.define("delivery-picker-cart", DeliveryPickerCart);
